import { Color } from '../../../enums/color'
import { Variant } from '../types/variant'

interface ChipStyles {
  textColor: Color
  borderColor: Color
}

export const variantStyles: Record<Variant, ChipStyles> = {
  error: {
    textColor: Color.Red700,
    borderColor: Color.Red100,
  },
  success: {
    textColor: Color.Green700,
    borderColor: Color.Green100,
  },
  successLight: {
    textColor: Color.Green300,
    borderColor: Color.Green100,
  },
  warning: {
    textColor: Color.Yellow700,
    borderColor: Color.Yellow100,
  },
}
